<template>
  <div class="text-center">
    <v-dialog id="dialog-select-month" v-model="dialog" persistent width="500">
      <v-card>
        <v-card-title id="card-title-select-month" class="text-h5 grey lighten-2"
          >Selecione um Mês</v-card-title
        >

        <v-card-text>
          <v-col id="col-select-month" class="d-flex" cols="12" sm="12">
            <v-select
              id="select-month"
              :items="$constants.meses"
              item-text="descricao"
              item-value="id"
              v-model="selectMonth"
              return-object
              label="Selecione um mês"
              solo
            ></v-select>
          </v-col>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="btn-fechar" color="text" @click="$emit('dialogChange', false)"> Fechar </v-btn>
          <v-btn id="btn-gerar" color="primary" text @click="tipoDiario"> Gerar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    gestao_id: {
      type: [Number, String],
      required: true,
    },
    tipo_diario: {
      type: Number,
      required: true,
    },
    tipoEnsino: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selectMonth: null,
    };
  },
  methods: {
    async tipoDiario() {
      if (this.tipo_diario === 1) {
        this.diarioFrequencia();
      }
      if (this.tipo_diario === 2) {
        this.diarioAulas();
      }
    },
    async diarioFrequencia() {
      try {
        if (!this.selectMonth) {
          throw new Error("Selecione um mês");
        }
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioFrequencia(
          this.gestao_id,
          this.selectMonth,
          this.tipoEnsino
        );
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async diarioAulas() {
      try {
        if (!this.selectMonth) {
          throw new Error("Selecione um mês");
        }
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.diarioAulas(
          this.gestao_id,
          this.selectMonth,
          this.tipoEnsino
        );
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
